// Kontexthilfe je Modul: ein "Hilfe"-Button, der das passende Direkthilfe-Blatt
// in einem Modal öffnet. Inhalt kommt aus dem generierten help-content (Single-Source).
import { openModal } from '@vario-connect/frontend-design';
import { helpSheetById } from '../generated/help-content.js';

// Ordnet jedem Modul-Slot das passende Blatt zu.
export const SLOT_HELP: Record<string, string> = {
  products: 'produktuebersicht',
  orders: 'bestellungen',
  log: 'protokoll',
  settings: 'einstellungen',
  'listing-status': 'artikel-detail',
  'account-customer-export': 'kunden-hersteller-export',
};

/** HTML für einen Hilfe-Button. `sheetId` = Blatt-ID aus help-content. */
export function helpButtonHtml(sheetId: string, label = 'Hilfe'): string {
  return (
    `<button type="button" class="kl-action-icon go-help-btn" data-help-sheet="${sheetId}" ` +
    `title="Hilfe zu diesem Bereich" aria-label="Hilfe zu diesem Bereich">` +
    `<span class="v-icon fa-light fa-circle-question" aria-hidden="true"></span>` +
    `<span class="go-help-btn__label">${label}</span>` +
    `</button>`
  );
}

/** Öffnet das Blatt als Modal. */
export function openHelpSheet(sheetId: string): void {
  const sheet = helpSheetById(sheetId);
  if (!sheet) {
    openModal({ title: 'Hilfe', body: '<p>Für diesen Bereich ist noch keine Hilfe hinterlegt.</p>',
      footer: '<button class="v-button" data-modal-cancel>Schließen</button>' });
    return;
  }
  openModal({
    title: sheet.title,
    icon: sheet.icon,
    width: 720,
    body: `<div class="kl-help-body">${sheet.html}</div>`,
    footer: '<button class="v-button" data-modal-cancel>Schließen</button>',
  });
}

/** Verkabelt alle [data-help-sheet]-Buttons innerhalb von `root`. */
export function wireHelpButtons(root: HTMLElement | Document = document): void {
  for (const btn of root.querySelectorAll<HTMLButtonElement>('[data-help-sheet]')) {
    if (btn.dataset.helpWired === '1') continue;
    btn.dataset.helpWired = '1';
    btn.addEventListener('click', () => openHelpSheet(btn.dataset.helpSheet!));
  }
}
